import { Box, Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import Icon from 'components/@icons/Icon';

const PreviewBanner = () => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'secondary.main',
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        position: 'fixed',
        width: '100%',
        bottom: 0,
        zIndex: 9999,
        color: 'common.black',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Icon
          name="WarningCircle"
          fontSize={24}
          sx={{ display: { xs: 'none', md: 'block' }, mr: 3 }}
        />

        <Typography variant="h6">
          <FormattedMessage id="preview.mode.title" />
        </Typography>
      </Box>
      <Button component="a" href={Routes.ApiExitPreview} color="inherit">
        <FormattedMessage id="preview.mode.exit" />
      </Button>
    </Box>
  );
};

export default PreviewBanner;
